import { useRouter } from 'next/router';
import { MendableFloatingButton, MendableSearch, MendableSearchBar,MendableChatBubble } from "@mendable/search";
import { FC } from 'react';

const style = { darkMode: false, accentColor: "#D4A480" }

const floatingButtonStyle = {
    color: "#000",
    backgroundColor: "#D4A480"
}



const ScreenshotComponent: FC = () => {
  return (
    <div className='relative bg-white h-screen'>
      <img 
        src="/anthropic-docs.png" 
        alt="Anthropic Docs Screenshot"
        style={{ width: '100%', maxHeight: '100vh' }} // Adjust dimensions as needed
      />
      
      {/* You can add other components or UI elements below */}
      <MendableFloatingButton welcomeMessage="Ask me about constructing prompts" anon_key='bdb57bd0-b901-47e5-acdb-b49e3e6ec312' style={style} floatingButtonStyle={floatingButtonStyle} icon="/anthropic_logo.png" />
    </div>
    
  );
}

export default ScreenshotComponent;